
module.exports = function(value) {
	var message = '';
	if (value.match(/[^a-zA-Z0-9\.\-]/)) {
		message = "Only alphanumerics, dots and hyphens permitted.";
	}
	if (value.match(/^[\.\-]/)) {
		message = "Domain cannot start with a hyphen nor a dot.";
	}
	if (value.match(/[\.\-]$/)) {
		message = "Domain cannot end with a hyphen nor a dot.";
	}
	if (value.match(/\.\./)) {
		message = "Domain cannot contain consecutive dots.";
	}
	if (value.length>253) {
		message = "Domain cannot be longer than 253 characters.";
	}
	return message;
}

